export default __webpack_public_path__ + "092477d60638d86f2651abf6a9a52c2e.png";